

import React, { memo, useState } from 'react';
import cx from 'classnames';
import _get from 'lodash.get';
import { getCostValue } from '@shootsta/cost-parsing-utils';
import { Dropdown, Button, Input } from '../../../../../../../ui-kit';
import EditCost from '../../EditCost';
import { isInvalidAddon, generateAddonId } from '../../../../../utils';
import { addonsWithRelatedInput } from '../../../../../constants/supersizeMyEditAddons';
import '../../../styles/_multiple-dropdown.scss';

















function onEditCostChange({
  value,
  selectedValue,
  setSelectedValue,
  onChange
}) {
  const oldCost = getCostValue(selectedValue);
  const reg = new RegExp(oldCost.toString());
  const newString = selectedValue && selectedValue.cost ? selectedValue.cost.replace(reg, value) : '';
  const updatedValue = { ...selectedValue, cost: newString };

  setSelectedValue(updatedValue);

  onChange(updatedValue);
}

const onSetRelatedInputValue = ({ value, selectedValue, setSelectedValue, onChange }) => {
  const newSelectedValue = { ...selectedValue, description: value };

  setSelectedValue(newSelectedValue);

  onChange(newSelectedValue);
};

const onChangeValue = ({ option, onChange }) => {
  const updatedOption = option.isMultiple ? { ...option, addonId: generateAddonId() } : option;

  onChange(updatedOption);
};

function MultipleDropdownItem({
  defaultValue,
  onDelete,
  onChange,
  label,
  placeholder,
  disabled,
  selectedValues,
  options
}) {
  const initialValue = defaultValue && options.find(
    (option) => option.value === defaultValue.value
  );
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const currentOptions = options.
  filter((option) => option.isMultiple || !selectedValues.
  map((item) => item.value).
  filter((value) => Boolean(value)).
  includes(option.value));

  const cost = getCostValue(selectedValue);
  const isShowRelatedInput = addonsWithRelatedInput.includes(selectedValue && selectedValue.value);
  const inputDefaultValue = _get(selectedValue, 'description', '');

  return (
    <div className="multiple-dropdown__item">
      <div className="multiple-dropdown__item-container">
        <div>
          <Dropdown
            options={currentOptions}
            onChange={(option) => onChangeValue({ option, onChange })}
            defaultValue={initialValue}
            placeholder={placeholder}
            label={label}
            hideSeparators
            disabled={disabled}
            type="BUTTON" />

          {
          onDelete && !disabled ?
          <Button prefix="trash" onClick={onDelete} type="TERTIARY" /> :
          null}

        </div>
        <div className="expandable-addon__children--content">
          {isShowRelatedInput &&
          <Input
            onBlur={({ value }) => onSetRelatedInputValue({
              value,
              selectedValue,
              setSelectedValue,
              onChange
            })}
            defaultValue={inputDefaultValue}
            placeholder="Enter 'Other' add-on description"
            disabled={disabled}
            className={cx('multiple-dropdown__item-input', { 'multiple-dropdown__item-input--invalid': !inputDefaultValue })} />}


        </div>
      </div>
      <EditCost
        onChangeCost={(value) => onEditCostChange({
          value,
          selectedValue,
          setSelectedValue,
          onChange
        })}
        disabled={disabled || !defaultValue || !defaultValue.value}
        cost={isInvalidAddon(selectedValue) ? 0 : cost} />

    </div>);

}

export default memo(MultipleDropdownItem);